module.exports = __webpack_public_path__ + "static/media/lost.0e4102d0.png";